import {Component} from '@angular/core';
import {FormBuilder, FormControl, FormGroup} from '@angular/forms';
import {MatDialogRef} from '@angular/material/dialog';
import {BucketName} from '@npck/af-frontend-api';
import {AttachmentForm, requiredFilesValidator} from '../../../../components/files/file/file.component';

@Component({
    selector: 'af-refund-execution-dialog',
    templateUrl: './refund-execution-dialog.component.html',
    styleUrl: './refund-execution-dialog.component.scss',
    standalone: false,
})
export class RefundExecutionDialogComponent {
    BucketName = BucketName;
    form: FormGroup<AttachmentForm>;

    constructor(
        public dialogRef: MatDialogRef<RefundExecutionDialogComponent>,
        private formBuilder: FormBuilder,
    ) {
        this.form = this.formBuilder.group({});
        this.form.addControl('fileType', new FormControl('PAYMENT_ORDER'));
        this.form.addControl('files', new FormControl(null, [requiredFilesValidator()]));
    }
}
